import { colors } from "@theme/colors"

const ArchiveIcon = ({ color = colors.iconPrimary, height = 16, width = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 13C13 13.4592 12.6267 13.8333 12.1667 13.8333H3.83333C3.37417 13.8333 3 13.4592 3 13V5.5H13V13ZM3 2.16667H13C13.46 2.16667 13.8333 2.54083 13.8333 3C13.8333 3.45917 13.46 3.83333 13 3.83333H3C2.54083 3.83333 2.16667 3.45917 2.16667 3C2.16667 2.54083 2.54083 2.16667 3 2.16667ZM15.5 3C15.5 1.62167 14.3783 0.5 13 0.5H3C1.62167 0.5 0.5 1.62167 0.5 3C0.5 3.73583 0.825833 4.39167 1.33333 4.85V13C1.33333 14.3783 2.455 15.5 3.83333 15.5H12.1667C13.545 15.5 14.6667 14.3783 14.6667 13V4.85C15.1742 4.39167 15.5 3.73583 15.5 3Z"
        fill={color}
      />
      <path
        d="M8 8V11M8 11L9 10.1429M8 11L7 10.1429"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ArchiveIcon
